import { SVLink } from '@/components/core';
import { Card, Stack, Typography } from '@mui/material';

export default function UnsupportedBrowser() {
  return (
    <Card>
      <Stack spacing={2}>
        <Typography variant="h4" component="h1">
          You are using an unsupported browser
        </Typography>
        <Typography>
          Internet Explorer 11 and IE Edge Compatability Mode are unsupported
          for 1Advisor. Please use a different browser or use our mobile
          application.
        </Typography>
        <SVLink to="https://www.microsoft.com/en-us/edge/download">
          Download Microsoft Edge
        </SVLink>
        <SVLink to="https://www.google.com/chrome/">Download Chrome</SVLink>
        <SVLink to="https://www.mozilla.org/en-US/firefox/new/">
          Download Firefox
        </SVLink>
      </Stack>
    </Card>
  );
}
